import store from '~/store'
import Cookies from 'js-cookie'

export default async (to, from, next) => {
  let is_emergency_login = sessionStorage.getItem('is_emergency_login');
  if (is_emergency_login) {
      const token = sessionStorage.getItem('token');
      if (token) {
        store.commit('auth/SAVE_TOKEN', { token, remember: false })
        await store.dispatch('auth/fetchUser')
        sessionStorage.clear();
      }
  }

  if (!store.getters['auth/check']) {
    Cookies.set('intended_url', to.fullPath)
    next({ name: 'login' })
  } else {
    next()
  }
}
